import { useRef, useState } from 'react';
import { useOnClickOutside } from '../../../hooks/useOnOutsideClick';

export const DropdownBase = ({ defaultState = false, render }) => {
  const [open, setOpen] = useState(defaultState);
  const ref = useRef();
  useOnClickOutside(ref, () => setOpen(false));
  return render({ open, setOpen, ref });
};
